import React, { Component } from 'react';
import { getToken } from '../../functions/app_functions.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';


export default class ProductFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            name: "",
            message: "",
            submitted: false
        };
        this.setFormValue = this.setFormValue.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
    }


    setFormValue(label, value) {
        this.setState({ [label]: value });
    }


    async sendRequest() {
        try {
            // Prepare data
            var data = {
                email: this.state.email,
                name: this.state.name,
                message: this.state.message
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/sendrequest", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    data: data,
                    subject: "Feedback"
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Set data to state
                this.setState({
                    email: "",
                    name: "",
                    message: "",
                    submitted: true
                });
            } else {
                // Track error
                var name = "";
                var message = "Could not send request. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Set data to state
            this.setState({
                missingdata: true
            });
            // Track error
            var name = "";
            var message = "Could not send request. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "ProductFeedback_sendRequest");
        }
    }


    render() {

        return (
            <div className="content-container">
                {!this.state.submitted &&
                    <div className="content-wrapper content-wrapper--vertical-padding">
                        <h1 className="section__title text-title">
                            We’d love your feedback
                        </h1>


                        <div className="section__textbox">
                            Guidr is built for the travel community—and we’re constantly working to make it better.
                            <br />
                            Your input helps shape the platform, so please take a moment to share what you love, what’s missing, or what could be improved. We carefully review every message we receive.
                        </div>

                        <div className="section__textbox">
                            <ForminputText
                                name={"name"}
                                label={"Name"}
                                value={this.state.name}
                                setFormValue={this.setFormValue.bind(this)}
                                required={true}
                            />
                        </div>

                        <div className="section__textbox">
                            <ForminputText
                                name={"email"}
                                label={"Email"}
                                value={this.state.email}
                                setFormValue={this.setFormValue.bind(this)}
                                required={true}
                            />
                        </div>

                        <div className="section__textbox">
                            <ForminputTextbox
                                name={"message"}
                                label={"Your Message"}
                                placeholder={"Tell use your feedback"}
                                value={this.state.message}
                                setFormValue={this.setFormValue.bind(this)}
                                required={false}
                            />
                        </div>

                        <div className="section__textbox">
                            <div onClick={this.sendRequest} className="button button-primary">
                                Submit feedback
                            </div>
                        </div>

                    </div>
                }
                {this.state.submitted &&
                    <div className="content-wrapper content-wrapper--vertical-padding">
                        <h1 className="section__title text-title">
                            Thank you for sharing your feedback
                        </h1>
                    </div>
                }
            </div>
        )
    }
}
